import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    firstName: {
      validations: [
        { type: 'required', message: 'Please provide a first name' },
        { type: 'maxLength', maxLength: 25, message: 'You have reached your maximum limit of characters allowed' },
      ]
    },
    lastName: {
      validations: [
        { type: 'required', message: 'Please provide a last name' },
        { type: 'maxLength', maxLength: 25, message: 'You have reached your maximum limit of characters allowed' },
      ]
    },
    telnumber: {
      validations: [
        { type: 'required', message: 'Please provide a telephone number' },
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number' }
      ]
    },
    email: {
      validations: [
        { type: 'required', message: 'Please provide an email' },
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email' }
      ]
    },
    clientname: {
      validations: [
        { type: 'maxLength', maxLength: 75, message: 'You have reached your maximum limit of characters allowed' },
      ]
    },
    eventDate: {
      validations: [
        { type: 'required', message: 'Please select a date for your event' },
        { type: 'dateinfuture', message: 'Preferred event date must be in the future' }
      ]
    },
    plannedguestcount: {
      validations: [
        { type: 'required', message: 'Please enter the number of guests' },
        { type: 'maxLength', maxLength: 10, message: 'You have reached your maximum limit of characters allowed' },
      ]
    },
    theme: {
      validations: [
        { type: 'required', message: 'Please enter type of event' },
        { type: 'maxLength', maxLength: 50, message: 'You have reached your maximum limit of characters allowed' },
      ]
    },
    reference: {
      validations: [
        { type: 'required', message: 'Please fill in required field' },
        { type: 'maxLength', maxLength: 50, message: 'You have reached your maximum limit of characters allowed' },
      ]
    },
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name *',
            mapping: 'firstName'
          },
          {
            type: 'text',
            size: 'Medium',
            label: 'Last Name *',
            mapping: 'lastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company/Group Name',
            mapping: 'clientname'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number *',
            mapping: 'telnumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email *',
            mapping: 'email'
          },
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Type of Event *',
            mapping: 'theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker',
            size: 'Medium',
            label: 'Date of Event *',
            mapping: 'eventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Guest Count *',
            mapping: 'plannedguestcount'
          }
        ]
      },

      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Message *',
            mapping: 'reference'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'Medium',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Whalers Contact Us Form',
    formId: '563',
    clientKey: '01A05603-9A62-41D0-A8F9-90807B060AE2',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you very soon!',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;



// WEBPACK FOOTER //
// /Users/leila/dev/inquiry-renderer/client_forms/whalers/form_structure.js